module.exports = __webpack_public_path__ + "img/back.78ef6c77.svg";